import api from '@/api';

export const actions = {

    adminSocietyUpdate({dispatch}, data) {
        return new Promise((resolve, reject) => {
            dispatch('commonStartLoading');

            api({url: 'users/societies/' + data.id, data: data, method: 'PUT'})
                .then(resp => {
                    dispatch('commonEndLoading');
                    resolve(resp.data);
                })
                .catch(err => {
                    dispatch('commonEndLoading');
                    reject(err)
                })
        })
    },

};
